import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserCmsProfile } from 'services/user-cms-profiles';
import { actionUserCmsChangeItem, actionUserCmsGetAllDynamic } from './actions';

interface Filters {
  search: string;
  userCmsProfilePermissionID: string;
}
interface Pagination {
  take: number;
  count: number;
  page: number;
}
interface OrderBy {
  field: string;
  order: 'desc' | 'asc' | null;
}
export interface IGridUserCms
  extends Pick<
    UserCmsProfile,
    | 'id'
    | 'appIdentityUserID'
    | 'userPhoto'
    | 'firstName'
    | 'lastName'
    | 'userCmsProfilePermissionID'
    | 'email'
    | 'isActive'
  > {
  role: string;
}

interface State {
  error: null | Error;
  isLoading: boolean;
  isInit: boolean;
  data: IGridUserCms[];
  filters: Filters;
  pagination: Pagination;
  orderBy: OrderBy;
}

const initState = (): State => {
  return {
    error: null,
    isLoading: false,
    isInit: false,
    data: [],
    filters: {
      search: '',
      userCmsProfilePermissionID: '',
    },
    pagination: {
      take: 10,
      count: 0,
      page: 1,
    },
    orderBy: {
      field: 'firstName,lastName',
      order: 'asc',
    },
  };
};

const slice = createSlice({
  name: 'USERS_CMS',
  initialState: initState(),
  reducers: {
    actionUserCmsRevalidateData(state) {
      state.isInit = false;
    },
    actionUserCmsFiltersSet(state, action: PayloadAction<Partial<Filters>>) {
      state.filters = { ...state.filters, ...action.payload };
    },
    actionUserCmsFiltersReset(state) {
      state.filters = initState().filters;
    },
    actionUserCmsOrderBySet(state, action: PayloadAction<Partial<OrderBy>>) {
      state.orderBy = { ...state.orderBy, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(actionUserCmsGetAllDynamic.pending, (state, action) => {
      state.isLoading = true;
      state.error = null;
      state.pagination.page = action.meta.arg ? action.meta.arg.page : state.pagination.page;
    });
    builder.addCase(actionUserCmsGetAllDynamic.fulfilled, (state, action) => {
      const {
        payload: { value, count },
      } = action;
      state.isLoading = false;
      state.isInit = true;
      state.data = value;
      state.pagination.count = count;
    });
    builder.addCase(actionUserCmsGetAllDynamic.rejected, (state, action) => {
      const { error } = action;
      state.isLoading = false;
      state.error = error;
      state.isInit = true;
    });
    builder.addCase(actionUserCmsChangeItem.fulfilled, (state) => {
      state.isInit = false;
    });
  },
});

export const { actionUserCmsOrderBySet, actionUserCmsFiltersSet, actionUserCmsRevalidateData } =
  slice.actions;
export const reducerUserCms = slice.reducer;
